import {formatTimeZoneDate} from '@hconnect/uikit'
import {LabelSmallRegular} from '@hm/fundamental'
import i18next from 'i18next'
import {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {ActionItem} from '../../types'

type ActionCreatorInfoProps = {
  action: ActionItem
  timeZone: string
}

const formatDateTime = (date: Date, timeZone: string): string =>
  `${formatTimeZoneDate(date, timeZone, 'll', i18next.language)} - ${formatTimeZoneDate(date, timeZone, 'LT', i18next.language)}`

export const ActionCreatorInfo: FC<ActionCreatorInfoProps> = ({action, timeZone}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <>
      {action.creator && (
        <LabelSmallRegular
          className="text-foreground_faded block"
          data-test-id="meta-annotation-created-by"
        >
          {t('actionDetails.createdBy', {
            name: action.creator.name,
            date: formatDateTime(action.createdAt, timeZone)
          })}
        </LabelSmallRegular>
      )}
      {action.updatedBy &&
        action.updatedAt &&
        action.updatedAt.getTime() !== action.createdAt.getTime() && (
          <LabelSmallRegular
            className="text-foreground_faded block"
            data-test-id="meta-annotation-modified-by"
          >
            {t('actionDetails.modifiedBy', {
              name: action.updatedBy.name,
              date: formatDateTime(action.updatedAt, timeZone)
            })}
          </LabelSmallRegular>
        )}
    </>
  )
}
